module.exports = __webpack_public_path__ + "files/04af506199e7d0831a31a8f09220678d.svg";